export const MODELO = {
  NFCE: '65',
  SAT: '59',
  GERENCIAL: 'GR',
};

export const MODELO_LABEL = {
  [MODELO.NFCE]: 'NFC-e',
  [MODELO.SAT]: 'SAT',
  [MODELO.GERENCIAL]: 'GERENCIAL',
};

export const PRINT = {
  NORMAL: 1,
  REDUCED: 2,
};

export const PRINT_LABEL = {
  [PRINT.NORMAL]: 'Impressão normal',
  [PRINT.REDUCED]: 'Impressão reduzida',
};

export const TECLAS = {
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  INSERT: 45,
};
